import UIStrings from '@/Utils/UIStrings';

interface InterviewConfirmDialogBodyProps {
    name: string;
}

function InterviewConfirmDialogBody({ name }: InterviewConfirmDialogBodyProps) {
    return (
        <div className="text-foreground text-sm font-normal">
            <span>{`${UIStrings.InterviewConfirmDialogBody1} `}</span>
            <span>{name}</span>
            <span>{UIStrings.InterviewConfirmDialogBody2}</span>
        </div>
    );
}

export default InterviewConfirmDialogBody;
